import {Rect} from './rect';

export class Circle extends Rect {
}
